import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../../pages/Home';
import Processos from '../../pages/Processos';
import Cadastro from '../../pages/Cadastro';
import Madeiras from '../../pages/Madeiras';
import NovoProcesso from '../../pages/NovoProcesso';
import { ContinuarProcessos } from '../../pages/ContinuarProcessos';
import Produzidos from '../../pages/Produzidos';
import Pedidos from '../../pages/Pedidos';
import PrivateRoute from '../../context/routes'; // Importa a rota privada
import { AuthProvider } from '../../context/authContext'; // Importa o provedor de autenticação
import LoginPage from '../../pages/LoginPage';
import Rastreio from '../../pages/Rastreio';

const Rotas = () => (
    <AuthProvider>
        <BrowserRouter>
            <Routes>
                {/* Rota pública */}
                <Route path="/" element={<LoginPage />} />
                <Route path='/rastreio/:uuid' element={<Rastreio />} />

                {/* Rotas privadas */}
                <Route element={<PrivateRoute />}>
                    <Route path="/home" element={<Home />} />
                    <Route path="/processos" element={<Processos />} />
                    <Route path="/cadastros" element={<Cadastro />} />
                    <Route path="/madeiras" element={<Madeiras />} />
                    <Route path="/novoProcesso" element={<NovoProcesso />} />
                    <Route path="/continuarProcessos" element={<ContinuarProcessos />} />
                    <Route path="/produzidos" element={<Produzidos />} />
                    <Route path="/pedidos" element={<Pedidos />} />
                </Route>
            </Routes>
        </BrowserRouter>
    </AuthProvider>
);

export default Rotas;
